import { motion } from 'framer-motion';
import { Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface HomeHeaderProps {
  userName: string | null;
}

export default function HomeHeader({ userName }: HomeHeaderProps) {
  const navigate = useNavigate();
  const firstName = userName?.split(' ')[0] || 'there';
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  return (
    <motion.div
      className="flex items-end justify-between mb-6 md:mb-10 lg:mb-12"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0, ease: [0.22, 1, 0.36, 1] }}
    >
      <div>
        <p className="font-sans text-base text-text-muted hidden md:block mb-4 md:text-xs md:uppercase md:tracking-[0.2em]">
          {today}
        </p>
        <p className="font-sans text-base text-text-muted md:hidden">
          Welcome back,
        </p>
        <h1 className="font-display font-semibold text-3xl md:text-6xl lg:text-7xl text-text-primary leading-tight md:leading-[0.95]">
          <span className="md:hidden">{firstName}</span>
          <span className="hidden md:inline italic font-light tracking-tight">
            Hello, {firstName}.
          </span>
        </h1>
      </div>
      <button
        onClick={() => navigate('/settings')}
        className="md:hidden p-2 rounded-xl hover:bg-primary-light transition-colors cursor-pointer"
      >
        <Settings size={24} className="text-text-muted" />
      </button>
    </motion.div>
  );
}
